import { NotificationManager } from "react-notifications";
import { cloneDeep, set } from "lodash";
import { GlobalAuthFetch } from "../../../../../../Utils/GlobalAuthFetch/GlobalAuthFetch";
import i18n from "../../../../../../Utils/i18next/i18next";

const { t } = i18n;

export const onSubmit = async (values, props) => {
  const { loadData, update, uuid } = props;
  const data = cloneDeep(values);

  if (values?.clientType?.value)
    set(data, "clientType", values?.clientType?.value);

  if (values?.representative?.value)
    set(data, "representative.uuid", values?.representative?.value);

  if (values?.eventType?.value)
    set(data, "eventType", values?.eventType?.value);

  if (values?.representativeDecisionType?.value)
    set(
      data,
      "representativeDecisionType",
      values?.representativeDecisionType?.value
    );

  if (values?.nextEventType?.value)
    set(data, "nextEventType", values?.nextEventType?.value);

  if (values?.offerStatus?.value)
    set(data, "offerStatus", values?.offerStatus?.value);
  
  if (values?.eventStatus?.value)
    set(data, "eventStatus.uuid", values?.eventStatus?.value);
  let payload;

  if (!update) {
    const res = await GlobalAuthFetch({
      path: `/crm/${uuid}/addCrmEvent`,
      method: "PATCH",
      data,
    });
    payload = res.payload;
  }

  if (update) {
    const res = await GlobalAuthFetch({
      path: `/crm/updateCrmEvent`,
      method: "PATCH",
      data,
    });
    payload = res.payload;
  }

  if (payload?.status >= 300 || !payload?.status) {
    props.setErrorHeader(0, true);

    return;
  }

  props.setErrorHeader(0, false);

  //Succes nofify
  loadData();
  NotificationManager.success(i18n.t("global:success"));
  // if (updateSingleRegistry) updateSingleRegistry();
  // if (updateTableRegistry) updateTableRegistry();
  props.handleHide();
};

export const onValidate = (values, props) => {
  const errorsStep0 = {};

  if (!values.eventType) {
    errorsStep0.eventType = t("global:crm.errors.eventType");
  }
  if (!values.representative) {
    errorsStep0.representative = t("global:crm.errors.representative");
  }

  if (!values.eventStatus) {
    errorsStep0.eventStatus = t("global:crm.errors.eventStatus");
  }

  if (!values.representativeDecisionType) {
    errorsStep0.representativeDecisionType = t(
      "global:crm.errors.representativeDecisionType"
    );
  }

  if (
    !props.steps[0]?.error &&
    props.isSubmit &&
    Object.keys(errorsStep0).length > 0
  ) {
    props.setErrorHeader(0, true);
  }
  if (
    !!props.steps[0]?.error &&
    props.isSubmit &&
    Object.keys(errorsStep0).length <= 0
  ) {
    props.setErrorHeader(0, false);
  }

  return { ...errorsStep0 };
};
